export const PLUGIN_MANIFEST_FILE = "manifest.json";
export const PLUGIN_THUMBNAIL_FILE = "thumbnail.png";
export const PLUGIN_MAX_FILE_SIZE = 1 * 1024 * 1024; // 1Mb. TODO: Move to config
export const PLUGIN_INDEX_FILE = "index.js";

// Libraries
export const LIBRARY_CORE_UUID = "core";

// Feature bundles
export const FEATURE_ADMIN_BUNDLE_ID = "mothership";
export const FEATURE_DEFAULT_BUNDLE_ID = "spark";

// Limits
export const FEATURE_GAME_DEFAULT_CREATE_LIMIT = 20;
export const FEATURE_GAME_DEFAULT_PUBLISH_LIMIT = 5;
export const FEATURE_STORAGE_DEFAULT_LIMIT = undefined;
